<template>
    <v-card class="mx-auto">
        <v-card-title>Chief Complaint</v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-textarea
                        v-model="formData.chief_complaint.chief_complaint"
                        outlined
                        name="input-7-4"
                        label="Chief Complaint"
                        required
                        :rules="[v => !!v || 'Chief Complaint is required']"
                ></v-textarea>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    :disabled="currentTab === 0"
                    @click="backTab"
                    color="info"
                    class="mr-4">
                BACK
            </v-btn>
            <v-btn
                    :disabled="!formData.chief_complaint.chief_complaint"
                    @click="validate"
                    color="success"
                    class="mr-4">
                NEXT
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    export default {
        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                valid: false,
            }
        },

        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.$bus.emit('nextTab', this.currentTab + 1);
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            }
        },
    }
</script>

<style scoped>

</style>
